import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'que-client-charge-filter',
  imports: [CommonModule, TranslateDirective, TranslatePipe],
  templateUrl: './client-charge-filter.component.html',
  styleUrls: ['./client-charge-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: ClientChargeFilterComponent, multi: true }]
})
export class ClientChargeFilterComponent {
  valueControl = new FormControl<boolean | null>(null);
  callBackFunction: Function = () => { };

  writeValue(obj: boolean | null): void {
    this.valueControl.setValue(obj ?? null);
  }

  registerOnChange(fn: any): void {
    this.callBackFunction = fn;
  }

  registerOnTouched(fn: any): void {
    // throw new Error('Method not implemented.');
  }

  // Single-value yes/no: clicking the already-selected option clears the filter back to "all".
  select(value: boolean): void {
    const newValue = this.valueControl.value === value ? null : value;
    this.valueControl.setValue(newValue);
    if (this.callBackFunction) {
      this.callBackFunction(newValue);
    }
  }
}
